import * as firebase from 'firebase';
//import firestore from 'firebase/firestore';
import "firebase/messaging";


const config = {
  apiKey: "AIzaSyAdYPhwZDdaZHSB_baQxsLA57XPgdz6py0",
  authDomain: "schoolerp-4fb2a.firebaseapp.com",
  databaseURL: "https://schoolerp-4fb2a.firebaseio.com",
  projectId: "schoolerp-4fb2a",
  storageBucket: "schoolerp-4fb2a.appspot.com",
  messagingSenderId: "640138604172",
  appId: "1:640138604172:web:54962fd00554fd68"
};
var init = firebase.initializeApp(config);
firebase.functions();






 navigator.serviceWorker.addEventListener("message", (message) => console.log(message));




export default firebase;